import styled from "styled-components";

export const BreadCrumb = styled.div`
.breadcrumb a, .breadcrumb a:hover {
    margin: 0;
    font-size: 15px;
    color: #086ad8;
}

.breadcrumb li.active a, .breadcrumb li.active a:hover  {
    color:#aaa;
    cursor: default;
    text-decoration: none;
}
.breadcrumb > li + li:before{
    color: #086ad8;
}


`;


// WEBPACK FOOTER //
// ./src/presentations/widgets/Breadcrumb/style.ts